import React, { useState } from 'react';
import './MobileDrawer.scss';

const MobileDrawer = ({ isOpen, onClose, history }) => {
   const [expandedSection, setExpandedSection] = useState(null);
   const [expandedSubSection, setExpandedSubSection] = useState(null);

   const careManagementItems = [
      {
         title: 'Care Delivery',
         items: [
            { icon: 'paper.png', title: 'Care Planning', description: 'Person-centred care plans', route: '/care-planning' },
            { icon: 'graph.png', title: 'Assessments', description: 'Comprehensive assessment tools', route: '/assessments' },
            { icon: 'file.png', title: 'Daily Logs', description: 'Digital care records & notes', route: '/daily_logs' },
            { icon: 'pharmacy.png', title: 'eMAR System', description: 'Digital medication records', route: '/emar-system' },
         ],
      },
      {
         title: 'Scheduling & Operations',
         items: [
            { icon: 'calender.png', title: 'Visit Rostering', description: 'Smart scheduling & shifts', route: '/visit-rostering' },
            { icon: 'location.png', title: 'Route Planning', description: 'Optimised travel routes', route: '/routeplan' },
            { icon: 'clock.png', title: 'Clock In/Out', description: 'GPS time tracking', route: '/clock-in-out' },
            { icon: 'receipt.png', title: 'Finance & Billing', description: 'Invoicing & payroll tools', route: '/finance-billing' },
         ],
      },
      {
         title: 'Mobile Solutions',
         items: [
            { icon: 'mobile-phone.png', title: 'Staff App', description: 'Offline-capable carer tools', route: '/staff-app' },
            { icon: 'group.png', title: 'Family App', description: 'Real-time care updates', route: '/family-app' },
            { icon: 'camera.png', title: 'Media & Notes', description: 'Photos, voice & signatures', route: '/media-notes' },
         ],
      },
      {
         title: 'Training & Development',
         items: [
            { icon: 'presentation.png', title: 'Care Training', description: 'Built-in courses & certificates', route: '/training' },
            { icon: 'reading-book.png', title: 'Learning Hub', description: 'Resources & best practices', route: '/learning-hub' },
            { icon: 'trophy.png', title: 'Skills Matrix', description: 'Track competencies', route: '/skills-matrix' },
         ],
      },
   ];
   const policiesStructure = {
      serviceTypes: [
         { icon: 'house.png', title: 'Domiciliary Care', description: 'Home care policies', route: '/domiciliary-care-policies' },
         { icon: 'swing.png', title: "Children's Home", description: 'Ofsted-compliant policies', route: '/children-homes-policies' },
         { icon: 'slhouse.png', title: 'Supported Living', description: 'Adult support services', route: '/supported-living-policies' },
         { icon: 'carehome.png', title: 'Care Home', description: 'CQC-ready policies', route: '/care-home-policies' },
         { icon: 'clinic.png', title: 'Supported Accommodation', description: 'Unregulated 16+ provision', route: '/supported-accomodation-policies' },
         { icon: 'calender.png', title: 'Temporary Staffing', description: 'Care worker agency policies', route: '/temporary-staffing-policies' },
      ],
      documentManagement: [
         { title: 'Document Vault', description: 'Secure storage with version control', route: '/document-vault' },
         { title: 'Smart Editor', description: 'Edit templates with compliance structure', route: '/smart-editor' },
         { title: 'Compliance Calendar', description: 'Track reviews and renewals', route: '/compliance-calendar' },
         { title: 'Export & Print', description: 'Generate inspection-ready PDFs', route: '/export-print' },
      ],
      documentFeatures: [
         { title: 'Update Alerts', description: 'Automatic regulatory notifications', route: '/update-alerts' },
         { title: 'Team Access', description: 'Role-based permissions', route: '/team-access' },
      ],
      byCountry: [
         { icon: 'england_flag.png', title: 'England', description: 'CQC & Ofsted aligned', country: 'england' },
         { icon: 'wales.png', title: 'Wales', description: 'CIW compliant', country: 'wales' },
         { icon: 'scotland.png', title: 'Scotland', description: 'Care Inspectorate ready', country: 'scotland' },
         { icon: 'wales.png', title: 'N. Ireland', description: 'RQIA standards', country: 'northern-ireland' },
      ],
      quickAccess: [
         { title: 'Document Pricing', route: '/policies-procedures' },
         { title: 'Document Search', route: '/documentlibrary' },
         { title: 'Update Centre', route: '/updates' },
      ],
   };

   const resourcesItems = [
      {
         title: 'Learn',
         items: [
            { icon: 'reading-book.png', title: 'Help Centre', description: 'Guides and tutorials', route: '/help-centre' },
            { icon: 'presentation.png', title: 'Training', description: 'Online courses & webinars', route: '/training' },
            { icon: 'working.png', title: 'Blog', description: 'Industry insights & tips', route: '/blog' },
         ],
      },
      {
         title: 'Support',
         items: [
            { icon: 'chat.png', title: 'Contact Support', description: 'Get help from our team', route: '/contact-us' },
            { icon: 'setting.png', title: 'System Status', description: 'Check service uptime', route: '/system-status' },
            { icon: 'mobile-phone.png', title: 'Product Tours', description: 'Self-guided walkthroughs', route: '/product-tours' },
         ],
      },
   ];

   const mainNavItems = [
      { id: 'care-management', label: 'Care Management', hasSubmenu: true },
      { id: 'policies', label: 'Policies & Procedures', hasSubmenu: true, hasNestedSections: true },
      { id: 'resources', label: 'Resources', hasSubmenu: true },
      // { id: 'pricing', label: 'Pricing', route: '/pricing' },
   ];

   const toggleSection = (sectionId) => {
      if (expandedSection === sectionId) {
         setExpandedSection(null);
         setExpandedSubSection(null);
      } else {
         setExpandedSection(sectionId);
         setExpandedSubSection(null);
      }
   };

   const toggleSubSection = (subSectionId) => {
      setExpandedSubSection(expandedSubSection === subSectionId ? null : subSectionId);
   };

   const handleNavigation = (route) => {
      if (route === '/blog') {
         window.location.href = 'https://www.caredaily.co.uk/blog';
      } else {
         history.push(route);
      }
      onClose();
   };

   const handleCountryNavigation = (country) => {
      history.push({ pathname: '/policies-procedures', state: { country: country } });
      onClose();
   };

   const renderPoliciesSubmenu = () => {
      if (expandedSection !== 'policies') return null;

      return (
         <div className="mobile-drawer__submenu">
            {/* Service Types - Expandable */}
            <div className="mobile-drawer__submenu-section">
               <button
                  className={`mobile-drawer__submenu-section-header ${expandedSubSection === 'service-types' ? 'active' : ''}`}
                  onClick={() => toggleSubSection('service-types')}
               >
                  <span>Service Types</span>
                  <svg
                     className={`mobile-drawer__nav-arrow ${expandedSubSection === 'service-types' ? 'mobile-drawer__nav-arrow--rotated' : ''}`}
                     xmlns="http://www.w3.org/2000/svg"
                     width="18"
                     height="18"
                     viewBox="0 0 24 24"
                     fill="none"
                     stroke="currentColor"
                     strokeWidth="2"
                  >
                     <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
               </button>
               {expandedSubSection === 'service-types' && (
                  <div className="mobile-drawer__submenu-items">
                     {policiesStructure.serviceTypes.map((item, index) => (
                        <div key={index} className="mobile-drawer__submenu-item" onClick={() => handleNavigation(item.route)}>
                           <div className="mobile-drawer__submenu-item-icon">
                              <img src={process.env.PUBLIC_URL + `/assets/images/careDaily/${item.icon}`} alt={item.title} width="20px" />
                           </div>
                           <div className="mobile-drawer__submenu-item-content">
                              <h5>{item.title}</h5>
                              <p>{item.description}</p>
                           </div>
                        </div>
                     ))}
                  </div>
               )}
            </div>

            {/* Document Management - Expandable */}
            <div className="mobile-drawer__submenu-section">
               <button
                  className={`mobile-drawer__submenu-section-header ${expandedSubSection === 'doc-management' ? 'active' : ''}`}
                  onClick={() => toggleSubSection('doc-management')}
               >
                  <span>Document Management</span>
                  <svg
                     className={`mobile-drawer__nav-arrow ${expandedSubSection === 'doc-management' ? 'mobile-drawer__nav-arrow--rotated' : ''}`}
                     xmlns="http://www.w3.org/2000/svg"
                     width="18"
                     height="18"
                     viewBox="0 0 24 24"
                     fill="none"
                     stroke="currentColor"
                     strokeWidth="2"
                  >
                     <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
               </button>
               {expandedSubSection === 'doc-management' && (
                  <div className="mobile-drawer__submenu-items">
                     {policiesStructure.documentManagement.map((item, index) => (
                        <div key={index} className="mobile-drawer__submenu-item" onClick={() => handleNavigation(item.route)}>
                           <div className="mobile-drawer__submenu-item-content">
                              <h5>{item.title}</h5>
                              <p>{item.description}</p>
                           </div>
                        </div>
                     ))}
                  </div>
               )}
            </div>

            {/* By Country - Expandable */}
            <div className="mobile-drawer__submenu-section">
               <button
                  className={`mobile-drawer__submenu-section-header ${expandedSubSection === 'by-country' ? 'active' : ''}`}
                  onClick={() => toggleSubSection('by-country')}
               >
                  <span>By Country</span>
                  <svg
                     className={`mobile-drawer__nav-arrow ${expandedSubSection === 'by-country' ? 'mobile-drawer__nav-arrow--rotated' : ''}`}
                     xmlns="http://www.w3.org/2000/svg"
                     width="18"
                     height="18"
                     viewBox="0 0 24 24"
                     fill="none"
                     stroke="currentColor"
                     strokeWidth="2"
                  >
                     <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
               </button>
               {expandedSubSection === 'by-country' && (
                  <div className="mobile-drawer__submenu-items">
                     {policiesStructure.byCountry.map((item, index) => (
                        <div key={index} className="mobile-drawer__submenu-item" onClick={() => handleCountryNavigation(item.country)}>
                           <div className="mobile-drawer__submenu-item-icon">
                              <img src={process.env.PUBLIC_URL + `/assets/images/careDaily/${item.icon}`} alt={item.title} width="20px" />
                           </div>
                           <div className="mobile-drawer__submenu-item-content">
                              <h5>{item.title}</h5>
                              <p>{item.description}</p>
                           </div>
                        </div>
                     ))}
                  </div>
               )}
            </div>

            {/* Quick Access */}
            <div className="mobile-drawer__submenu-section">
               <button
                  className={`mobile-drawer__submenu-section-header ${expandedSubSection === 'quick-access' ? 'active' : ''}`}
                  onClick={() => toggleSubSection('quick-access')}
               >
                  <span>Quick Access</span>
                  <svg
                     className={`mobile-drawer__nav-arrow ${expandedSubSection === 'quick-access' ? 'mobile-drawer__nav-arrow--rotated' : ''}`}
                     xmlns="http://www.w3.org/2000/svg"
                     width="18"
                     height="18"
                     viewBox="0 0 24 24"
                     fill="none"
                     stroke="currentColor"
                     strokeWidth="2"
                  >
                     <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
               </button>
               {expandedSubSection === 'quick-access' && (
                  <div className="mobile-drawer__submenu-items">
                     {policiesStructure.quickAccess.map((item, index) => (
                        <div key={index} className="mobile-drawer__submenu-item" onClick={() => handleNavigation(item.route)}>
                           <div className="mobile-drawer__submenu-item-content">
                              <h5>{item.title}</h5>
                           </div>
                        </div>
                     ))}
                  </div>
               )}
            </div>
         </div>
      );
   };

   const renderCareManagementSubmenu = () => {
      if (expandedSection !== 'care-management') return null;

      return (
         <div className="mobile-drawer__submenu">
            {careManagementItems.map((group, groupIndex) => (
               <div key={groupIndex} className="mobile-drawer__submenu-group">
                  <h4 className="mobile-drawer__submenu-group-title">{group.title}</h4>
                  {group.items.map((item, itemIndex) => (
                     <div key={itemIndex} className="mobile-drawer__submenu-item" onClick={() => handleNavigation(item.route)}>
                        <div className="mobile-drawer__submenu-item-icon">
                           <img src={process.env.PUBLIC_URL + `/assets/images/careDaily/${item.icon}`} alt={item.title} width="20px" />
                        </div>
                        <div className="mobile-drawer__submenu-item-content">
                           <h5>{item.title}</h5>
                           <p>{item.description}</p>
                        </div>
                     </div>
                  ))}
               </div>
            ))}
         </div>
      );
   };

   const renderResourcesSubmenu = () => {
      if (expandedSection !== 'resources') return null;

      return (
         <div className="mobile-drawer__submenu">
            {resourcesItems.map((group, groupIndex) => (
               <div key={groupIndex} className="mobile-drawer__submenu-group">
                  <h4 className="mobile-drawer__submenu-group-title">{group.title}</h4>
                  {group.items.map((item, itemIndex) => (
                     <div key={itemIndex} className="mobile-drawer__submenu-item" onClick={() => handleNavigation(item.route)}>
                        <div className="mobile-drawer__submenu-item-icon">
                           <img src={process.env.PUBLIC_URL + `/assets/images/careDaily/${item.icon}`} alt={item.title} width="20px" />
                        </div>
                        <div className="mobile-drawer__submenu-item-content">
                           <h5>{item.title}</h5>
                           <p>{item.description}</p>
                        </div>
                     </div>
                  ))}
               </div>
            ))}
         </div>
      );
   };

   return (
      <>
         {/* Backdrop */}
         <div className={`mobile-drawer__backdrop ${isOpen ? 'mobile-drawer__backdrop--active' : ''}`} onClick={onClose} />

         {/* Drawer */}
         <div className={`mobile-drawer ${isOpen ? 'mobile-drawer--open' : ''}`}>
            {/* Header */}
            <div className="mobile-drawer__header">
               {/* <div className="mobile-drawer__logo">
                  <img src={process.env.PUBLIC_URL + '/assets/images/careDaily/logo.png'} alt="Care Daily" height="32px" />
               </div> */}
               <button className="mobile-drawer__close" onClick={onClose}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                     <line x1="18" y1="6" x2="6" y2="18"></line>
                     <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
               </button>
            </div>

            {/* Navigation */}
            <div className="mobile-drawer__nav">
               {mainNavItems.map((item) => (
                  <div key={item.id} className="mobile-drawer__nav-item">
                     <button
                        className={`mobile-drawer__nav-button ${expandedSection === item.id ? 'mobile-drawer__nav-button--active' : ''}`}
                        onClick={() => {
                           if (item.hasSubmenu) {
                              toggleSection(item.id);
                           } else {
                              handleNavigation(item.route);
                           }
                        }}
                     >
                        <span>{item.label}</span>
                        {item.hasSubmenu && (
                           <svg
                              className={`mobile-drawer__nav-arrow ${expandedSection === item.id ? 'mobile-drawer__nav-arrow--rotated' : ''}`}
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                           >
                              <polyline points="6 9 12 15 18 9"></polyline>
                           </svg>
                        )}
                     </button>
                     {item.id === 'care-management' && renderCareManagementSubmenu()}
                     {item.id === 'policies' && renderPoliciesSubmenu()}
                     {item.id === 'resources' && renderResourcesSubmenu()}
                  </div>
               ))}
            </div>

            {/* Footer Actions */}
            <div className="mobile-drawer__footer">
               <button className="mobile-drawer__login-btn" onClick={() => handleNavigation('/login')}>
                  Login
               </button>
               <button className="mobile-drawer__demo-btn" onClick={() => handleNavigation('/book-demo')}>
                  Book a Demo
               </button>
            </div>
         </div>
      </>
   );
};

export default MobileDrawer;
